import { getFundHoldings } from '../../api/fund.api';
import { FundHoldingItem } from '../../types/fundsummary.type';
import useFundResource, { FundResourceResult } from './useFundResource';

const useFundHoldings = (
  ric: string = '',
  token: string = '',
  saleInCountryCode: string = 'US',
): FundResourceResult<FundHoldingItem[]> =>
  useFundResource<FundHoldingItem[]>(
    getFundHoldings,
    ric,
    token,
    saleInCountryCode,
  );

export default useFundHoldings;
